import api from './api';

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// // Create axios instance with default config
// const api = axios.create({
//   baseURL: API_URL,
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

const caregiverService = {
  // Create caregiver
  createCaregiver: async (practiceId, caregiverData) => {
    const response = await api.post(`/practices/${practiceId}/caregivers`, caregiverData);
    return response;
  },

  // Get all caregivers for a practice
  getCaregivers: async (practiceId, params = {}) => {
    const response = await api.get(`/practices/${practiceId}/caregivers`, { params });
    return response;
  },

  // Get caregiver by ID
  getCaregiver: async (practiceId, caregiverId) => {
    const response = await api.get(`/practices/${practiceId}/caregivers/${caregiverId}`);
    return response;
  },

  // Update caregiver
  updateCaregiver: async (practiceId, caregiverId, caregiverData) => {
    const response = await api.put(`/practices/${practiceId}/caregivers/${caregiverId}`, caregiverData);
    return response;
  },

  // Delete caregiver
  deleteCaregiver: async (practiceId, caregiverId) => {
    const response = await api.delete(`/practices/${practiceId}/caregivers/${caregiverId}`);
    return response;
  }
};

export default caregiverService;
